// extracted by mini-css-extract-plugin
module.exports = {"close":"CloseIcon_close__1iR8w","icon":"CloseIcon_icon__yIRVE"};